import { render, staticRenderFns } from "./com-package-order-search.vue?vue&type=template&id=8258f6aa&"
import script from "./com-package-order-search.vue?vue&type=script&lang=js&"
export * from "./com-package-order-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports